<script>
import Layout from "../../_layouts/main"
import PageHeader from "@/components/page-header"
import Document from '../../../components/api/document'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Document
  },
  data() {
    return {
      title: this.$t('배팅 목록'),
      apiUrl: process.env.VUE_APP_API_SERVER_URL + 'transactions',
      response: '',
      body: {
        username: { type: 'text', value: '', desc: this.$t('text.api.siteUsername_desc'), required: false },
        seamlessState: { type: 'text', value: '', desc: '심리스 사용시 전송 결과(finish, error)', required: false },
        beginDate: { type: 'date', value: null, desc: this.$t('text.api.beginDate_desc'), required: true },
        endDate: { type: 'date', value: null, desc: this.$t('text.api.endDate_desc'), required: false },
        limit: { type: 'number', value: '100', desc: this.$t('text.api.limit_desc'), required: true }
      }
    };
  },
  mounted() {
    /*
    let host = location.host
    if (host.indexOf('localhost') > -1 || host.indexOf('127.0.0.1') > -1) {
      host = 'http://127.0.0.1:39011/'
    } else {
      host = `https://api.${host}/`
    }

     */
    const host = process.env.VUE_APP_API_SERVER_URL
    this.apiUrl = host + 'transactions'

    // 응답값 설정
    this.response = '{\n' +
        ' "code": 0, \t\t\t\t\t\t\t// 응답값(0이 아니면 오류)\n' +
        ' "length": 519 \t\t\t\t\t\t\t// 갯수(최대 2,000개),\n' +
        ' "beginDate": "2022-08-30T16:29:00.455Z", \t\t\t// 다음 검색 시작일자(UTC Time = 한국시간 - 9시간 )\n' +
        ' "transactions": [ \t\t\t\t\t\t// 목록\n' +
        '  {\n' +
        '   "_id": "6305a14308b633b826da1c2e",\n' +
        '   "transactionKey": "b4a74e793da145d3edfd44c538bff2d6", \t// 고유키\n' +
        '   "gameCategoryKey": "slot", \t\t\t\t\t// 게임종류\n' +
        '   "gameKey": "vswaysdogs", \t\t\t\t\t// 게임코드\n' +
        '   "gameName": "The Dog House Megaways", \t\t\t// 게임명\n' +
        '   "gameTypeKey": "slot" \t\t\t\t\t// 게임형식,\n' +
        '   "isBonus": false, \t\t\t\t\t\t// 보너스 여부\n' +
        '   "isJackpot": false, \t\t\t\t\t\t// 잭팟 여부\n' +
        '   "isPromo": false, \t\t\t\t\t\t// 프로모션 여부\n' +
        '   "isFreeGame": false, \t\t\t\t\t// 프리게임 여부\n' +
        '   "groupKey": "", \t\t\t\t\t\t// 사이트에서 지정한 그룹코드\n' +
        '   "amount": 200, \t\t\t\t\t\t// 금액\n' +
        '   "createdAt": "2022-08-24T03:55:47.425Z", \t\t\t// 처리 시간(UTC Time)\n' +
        '   "requestedAt": "2022-08-24T03:55:47.625Z", \t\t\t// 요청 받은 시간(UTC Time)\n' +
        '   "username": "top1_21", \t\t\t\t\t// API용 회원코드\n' +
        '   "siteUsername": "user1" \t\t\t\t\t// 사이트 회원코드,\n' +
        '   "type": "bet", \t\t\t\t\t\t// 거래형식(bet, win, lose, draw, cancel)\n' +
        '   "vendorKey": "pragmatic_slot", \t\t\t\t// 게임사 코드\n' +
        '   "key": "6305a1431630f63ddf4cd5ff" \t\t\t\t// 게임 본래 코드,\n' +
        '   "parentTransactionKey": null \t\t\t\t// 부모 코드\n' +
        '   "seamlessState": finish \t\t\t\t// 심리스인 경우 처리 상태코드(error, finish)\n' +
        '  },\n' +
        '  .\n' +
        '  .\n' +
        '  .\n' +
        ' ]\n' +
        '}'
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title"><span class="badge bg-primary">요청 URL</span> {{ apiUrl }}</div>
            <div class="card-title-desc">{{ $t('text.api_transactions_desc')}}</div>
            <hr/>
            <Document :data="body" :apiUrl="apiUrl" :response="response" :require-vendors="false" :require-ip-address="false" :require-request-key="false" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
